import { render, staticRenderFns } from "./ArtworkForm.vue?vue&type=template&id=38002cb9&scoped=true&"
import script from "./ArtworkForm.vue?vue&type=script&lang=js&"
export * from "./ArtworkForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=38002cb9&scoped=true&lang=css&"
import style1 from "./ArtworkForm.vue?vue&type=style&index=1&id=38002cb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38002cb9",
  null
  
)

export default component.exports